interface SummaryRowProps {
  label: string
  value?: string
}

export function SummaryRow({ label, value }: SummaryRowProps) {
  return (
    <div className="flex items-start justify-between gap-3 text-sm">
      <div className="font-medium text-gray-light-700">{label}</div>
      <div className="text-right font-semibold text-gray-light-900">{value ?? '-'}</div>
    </div>
  )
}
